import React, { useEffect, useState } from "react"
import { FunctionComponent } from "react"
import { ContactViewModel } from "../../../common/api/Contacts/ContactsApi"
import Table from "@murphy-frontend/web-core/components/Table"
import { ColumnHeaderCell, ColumnRowCell } from "@murphy-frontend/web-core/components/Table/Models"
import { useUserPreferences } from "../../../common/contexts/UserPreferencesContext"

interface IContactListTable {
	contacts: ContactViewModel[]
}

export const ContactListTable: FunctionComponent<IContactListTable> = ({ contacts }) => {
	const [rows, setRows] = useState<ColumnRowCell[][]>([])
	const [columns, setColumns] = useState<ColumnHeaderCell[]>([])
	const { translations } = useUserPreferences()

	useEffect(() => {
		let newRows = contacts.map((contact, idx) => {
			return [
				{
					id: contact.id,
					rowId: idx,
					displayValue: contact.name,
					value: contact.name,
					columnKey: "name"
				},
				{
					id: contact.id,
					rowId: idx,
					displayValue: contact.email,
					value: contact.email,
					columnKey: "email"
				},
				{
					id: contact.id,
					rowId: idx,
					displayValue: contact.mobile || "-",
					value: contact.mobile || "-",
					columnKey: "phone"
				}
			]
		})
		const cols = [
			{
				columnKey: "name",
				displayName: translations.nam || "Name",
				isSortable: true,
				size: "column-medium"
			},
			{
				columnKey: "email",
				displayName: translations.email || "Email",
				isSortable: true,
				size: "column-medium"
			},
			{
				columnKey: "phone",
				displayName: translations.phonenumber || "Phone number",
				isSortable: true,
				size: "column-medium"
			}
		]
		setRows(newRows)
		setColumns(cols)
	}, [contacts])

	return (
		<div className="contact-table-wrapper">
			<Table rows={rows} columns={columns} key={"user"} />
		</div>
	)
}